// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".label-area[data-v-5e2cc60a]{border-bottom:1px solid hsla(0,0%,80.8%,.3);display:flex;justify-content:space-between}.label[data-v-5e2cc60a]{color:#333;font-size:16px;font-weight:700;border-bottom:1px solid #6e6e6e}.more-link-pc[data-v-5e2cc60a]{color:#6e6e6e;font-size:14px;font-weight:700;text-decoration:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
